// extracted by mini-css-extract-plugin
module.exports = {"logoutSection":"logoutSection-Eb7O0","logoutButton":"logoutButton-dkBdC","centered":"centered-BIedS"};